module.exports = __webpack_public_path__ + "static/media/hsc-lesson-plans.f3319bc1.jpg";